<template>
  <v-dialog v-model="dialog" max-width="400px">
    <v-card>
      <v-card-title>更改密码</v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-text-field
            v-model.trim="password"
            :rules="passwordRules"
            label="新密码"
            type="password"
            required
            @input="handlePasswordInput"
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" text @click="close">取消</v-btn>
        <v-btn color="primary" text @click="submit" :loading="loading">
          更改
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { userApi } from '@/api/user'

export default {
  name: 'ChangePasswordDialog',
  
  data() {
    return {
      dialog: false,
      valid: true,
      loading: false,
      password: '',
      userId: null,
      passwordRules: [
        v => !!v || "密码是必填项",
        v => (v && v.length >= 8) || "密码至少需要8个字符",
        v => /^[a-zA-Z0-9@._]+$/.test(v) || "密码只能包含英文字母、数字、@、_ 和 ."
      ]
    }
  },

  methods: {
    handlePasswordInput(value) {
      this.password = value.replace(/[^a-zA-Z0-9@._]/g, '');
    },

    open(userId) {
      this.userId = userId;
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.password = '';
        this.userId = null;
        this.$refs.form.resetValidation();
      });
    },

    async submit() {
      if (!this.$refs.form.validate()) return;
      
      this.loading = true;
      try {
        await userApi.updateJobSeekerPassword(this.userId, this.password);
        this.close();
        this.$toast.success('密码修改成功');
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message || '未知错误';
        this.$toast.error('修改失败：' + errorMessage);
      } finally {
        this.loading = false;
      }
    }
  }
}
</script> 